module.exports = __webpack_public_path__ + "img/comming-soon.2dbdef60.svg";